module.exports = __webpack_public_path__ + "static/media/maps-direction.ef01eea2.svg";